<p-toast [life]="6000">
  <ng-template let-message #message>
    <div class="message-content">
      <div class="info">
        @if (message.summary) {
          <app-typography type="headline4" [bold]="true"
                          [color]="isWhiteColor(message.severity)">{{ message.summary }}
          </app-typography>
        }
        <app-typography [color]="isWhiteColor(message.severity)">{{ message.detail }}</app-typography>
      </div>
      @if (router.url.includes('admin') && message.data; as data) {
        <div class="actions">
          @for (action of data; track action) {
            @if (action.actionType == 'button') {
              <app-action-btn [action]="action">
                <app-typography>{{ action.button?.title | translation }}</app-typography>
              </app-action-btn>
            } @else if (action.actionType == 'link') {
              <app-action-link [action]="action">
                <app-typography>{{ action.button?.title | translation }}</app-typography>
              </app-action-link>
            }
          }
        </div>
      }
    </div>

  </ng-template>
</p-toast>
